import { data } from '../../svg/Reply/data';
import { makeIcon } from '../makeIcon';

export const Reply = makeIcon(data, 'reply', 'Reply');

export default Reply;
